import React from 'react';
import PropTypes from 'prop-types';
import { Lines } from './styles';
import { WEEK } from '../../../utils';

const isWeekend = (date, viewBy) =>
  viewBy === WEEK && (date.getDay() === 6 || date.getDay() === 0);

const VerticalLines = ({ headers, size, viewBy }) => {
  const validCombinations = [
    { length: 7, index: 3 },
    { length: 5, index: 2 },
  ];

  const checkCombination = ([length, index]) => {
    return !!validCombinations.find(
      vc => vc.length === length && vc.index === index,
    );
  };

  return (
    <>
      {headers.map((header, index) => (
        <Lines
          key={header.id}
          divideBy={headers.length}
          size={size}
          isWeekend={isWeekend(header.date, viewBy)}
          backgroundToBlue={checkCombination([headers.length, index])}
        />
      ))}
    </>
  );
};

VerticalLines.propTypes = {
  viewBy: PropTypes.number,
  size: PropTypes.number.isRequired,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.instanceOf(Date).isRequired,
      format: PropTypes.string,
      id: PropTypes.number,
    }),
  ).isRequired,
};

VerticalLines.defaultProps = {
  viewBy: null,
};

export default VerticalLines;
